import pluralize from "pluralize";
import { box } from "tweetnacl";
import { encodeBase64 } from "tweetnacl-util";

/**
 * Returns formatted label for "all" policy in a resource-type. If second
 * second character in name is uppercase, assume acronym and return name.
 * Otherwise, make first character lowercase.
 * @param {String}
 * @returns {String}
 */
export const allResourceTypeLabel = name => {
  const label =
    name.charAt(1).toUpperCase() === name.charAt(1)
      ? pluralize(name)
      : pluralize(`${name.charAt(0).toLowerCase()}${name.slice(1)}`);

  return `All ${label}`;
};

/**
 * Converts a JS object into JSON with 4 space formatting.
 * @param {Object}
 * @returns {String}
 */
export const convertObjToJSON = obj => {
  if (typeof obj === "object") {
    return JSON.stringify(obj, null, 4);
  }
  throw new TypeError(
    `Argument has the wrong type; want string, got ${typeof obj}.`
  );
};

/**
 * Generates a public/private keypair formatted for use in registering services.
 * @param {Object}
 * @returns {String}
 */
export const generateKeys = () => {
  const keyPair = box.keyPair();
  return {
    public: encodeBase64(keyPair.publicKey),
    private: encodeBase64(keyPair.secretKey)
  };
};

/**
 * Parses domain from a username or group name string.
 * @param {String} user.username or group.name
 * @returns {Object}
 */
export const parseName = str => {
  if (str.includes("@")) {
    const pos = str.lastIndexOf("@");
    return {
      name: str.substring(0, pos),
      domain: str.substring(pos + 1)
    };
  }
  return {
    name: str,
    domain: undefined
  };
};

/**
 * Gets base path for a modal, i.e. '/policies/services`
 * @param {Object} location location object
 * @returns {String} base path
 */
export const getModalBasePath = location => {
  const path = location.pathname.split("/");
  return `/${path[1]}/${path[2]}`;
};
